import { Component, useEffect } from "react";
import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
import PageGeneratorComponent from './components/organisms/PageGenerator/PageGeneratorComponent';
import Survey from "./pages/Survey";
import Section from "./pages/Section";

import AdditionalComments from "./pages/AdditionalComments";
import MainLayout from "./components/molecules/layouts/MainLayout";
import MainSurveyLayout from "./components/molecules/layouts/MainSurveyLayout";
import Feedback from "./components/organisms/Feedback";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the #root element which is the actual scrollable container
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.scrollTop = 0;
    }
    // Also try window scroll as fallback
    window.scrollTo(0, 0);
    
    // Additional scroll after render
    requestAnimationFrame(() => {
      if (rootElement) {
        rootElement.scrollTop = 0;
      }
      window.scrollTo(0, 0);
    });
  }, [pathname]);

  return null;
}

export class Routes extends Component {
  render() {
    return (
      <BrowserRouter >
        <ScrollToTop />
        <Switch>
          <Route path='/survey/results' exact>
            <MainLayout>
              <Switch>
                <Route path='/survey/results' exact component={PageGeneratorComponent} />
             </Switch>
            </MainLayout>
          </Route>


          <Route path='/survey/:path/:n?'>
            <MainSurveyLayout>
              <Switch>
                <Route path='/survey' exact component={Survey} />
                <Route path='/survey/section/:sectionNumber' component={Section} />
                <Route path='/survey/additional-comments' exact component={AdditionalComments} />
                
                <Route component={(props) => <PageGeneratorComponent {...props} isPageNotFound={true}/>} exact path='/survey/*' />
              </Switch>
            </MainSurveyLayout>
          </Route>

        
          <Route>
            <MainLayout>
              <Switch>
                <Route path='/' exact component={ PageGeneratorComponent } />
                <Route path='/feedback' exact component={ Feedback } />
                <Route path='/survey-onboarding' exact component={PageGeneratorComponent} />
                <Route path='/lapaz' exact component={PageGeneratorComponent} />
                <Route path='/apoyopositivo' exact component={PageGeneratorComponent} />
                <Route component={(props) => <PageGeneratorComponent {...props} isPageNotFound={true}/>} isErrorPage={true} exact path="/*" />
              </Switch>
            </MainLayout>
          </Route>
        </Switch>
      </BrowserRouter>
    )
  }
}